import { prefixerM } from './common'

export const ROUTE_MANTENIMIENTO_CARGO = prefixerM('cargo')
